// BL-924: shared register of everything the Kodif launcher has to clear.
// The launcher is a fixed iframe with the maximum z-index, so nothing pinned
// to the bottom of the viewport can be stacked above it — KodifLauncherOffset
// lifts the launcher by the tallest registered height instead. Sources report
// 0 (or unmount) when they stop occupying the bottom of the screen.

const heights = new Map();
const listeners = new Set();

const maxHeight = () => (heights.size ? Math.max(...heights.values()) : 0);

const notify = () => {
  const height = maxHeight();
  listeners.forEach((listener) => listener(height));
};

export const setLauncherClearance = (key, height) => {
  if (height > 0) {
    if (heights.get(key) === height) return;
    heights.set(key, height);
  } else if (!heights.delete(key)) {
    return;
  }
  notify();
};

export const subscribeLauncherClearance = (listener) => {
  listeners.add(listener);
  listener(maxHeight());
  return () => listeners.delete(listener);
};
